import { render, staticRenderFns } from "./HardSoftConsonants.vue?vue&type=template&id=59501c6c&lang=pug&"
import script from "./HardSoftConsonants.vue?vue&type=script&lang=js&"
export * from "./HardSoftConsonants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports